module.exports = __webpack_public_path__ + "lirr.f63ab36c.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/images/neighborhood/full/lirr.jpg
// module id = 663
// module chunks = 0